import { render, staticRenderFns } from "./SensitiveAddDialog.vue?vue&type=template&id=47774530&scoped=true&"
import script from "./SensitiveAddDialog.vue?vue&type=script&lang=js&"
export * from "./SensitiveAddDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47774530",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47774530')) {
      api.createRecord('47774530', component.options)
    } else {
      api.reload('47774530', component.options)
    }
    module.hot.accept("./SensitiveAddDialog.vue?vue&type=template&id=47774530&scoped=true&", function () {
      api.rerender('47774530', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/sensitiveWord/SensitiveAddDialog.vue"
export default component.exports